import { jsx as _jsx } from "react/jsx-runtime";
import { useCardTracking } from '@aviv-classified-card/card/full';
import { FavoriteHeart as ConsumerPortalFavoriteHeart } from '@seeker-consumer-portal/favorite-heart';
import { useBrandConfiguration } from '../../../brands/context';
export const FavoriteHeart = ({ id, listName }) => {
    const { mfes: { favoriteHeartBrandId }, } = useBrandConfiguration();
    const tracking = useCardTracking(id);
    // TODO: This could be removed as soon as the card BDD service is returning the correct tracking values for list_name
    // Override list_name attributes in favorite heart tracking to the correct value
    if (tracking)
        tracking.list_name = listName;
    return favoriteHeartBrandId && _jsx(ConsumerPortalFavoriteHeart, { classifiedId: id, tracking: tracking });
};
